import { daDK, enUS } from '@mui/x-data-grid/locales';
import {
  LanguageProvider as PackageLanguageProvider,
  getStoredLanguage,
  initTranslations,
  useLanguage as usePackageLanguage
} from '@nps.today/translations';
import type { FunctionComponent, ReactNode } from 'react';
import da from '../translation/src/da.json';
import en from '../translation/src/en.json';

const SUPPORTED_LANGUAGES = ['da', 'en'];

const getLocale = (language: string): typeof enUS => (language === 'da' ? daDK : enUS);

initTranslations({
  translations: { da, en },
  language: getStoredLanguage({ supportedLanguages: SUPPORTED_LANGUAGES, fallbackLanguage: 'en' })
});

export const useLanguage = () => {
  const { language, dispatch } = usePackageLanguage();
  return { language, dispatch, locale: getLocale(language) };
};

interface LanguageProviderProps {
  children: ReactNode;
}

export const LanguageProvider: FunctionComponent<LanguageProviderProps> = ({ children }) => (
  <PackageLanguageProvider supportedLanguages={SUPPORTED_LANGUAGES} fallbackLanguage="en">
    {children}
  </PackageLanguageProvider>
);
